function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.5 31.1719C43.1734 31.1679 39.9841 29.8374 37.6318 27.472C35.2795 25.1067 33.9563 21.8998 33.9524 18.5547V14.1016C33.9563 10.7565 35.2795 7.54953 37.6318 5.1842C39.9841 2.81887 43.1734 1.4883 46.5 1.48438V1.48438C49.8267 1.4883 53.0159 2.81887 55.3682 5.1842C57.7205 7.54953 59.0437 10.7565 59.0476 14.1016V18.5547C59.0437 21.8998 57.7205 25.1067 55.3682 27.472C53.0159 29.8374 49.8267 31.1679 46.5 31.1719Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9524 14.8438H59.0476",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M42.8095 1.48438V8.90625",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M50.1905 1.48438V8.90625",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1905 72.7344H1.4762V86.0938H19.1905V87.5781C19.1905 88.3655 19.5015 89.1206 20.0552 89.6774C20.6089 90.2341 21.3598 90.5469 22.1429 90.5469C22.9259 90.5469 23.6768 90.2341 24.2305 89.6774C24.7842 89.1206 25.0952 88.3655 25.0952 87.5781V71.25C25.0952 70.4626 24.7842 69.7075 24.2305 69.1508C23.6768 68.594 22.9259 68.2812 22.1429 68.2812C21.3598 68.2812 20.6089 68.594 20.0552 69.1508C19.5015 69.7075 19.1905 70.4626 19.1905 71.25V72.7344Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M73.8095 72.7344H91.5238V86.0938H73.8095V87.5781C73.8095 88.3655 73.4985 89.1206 72.9448 89.6774C72.3911 90.2341 71.6402 90.5469 70.8572 90.5469C70.0741 90.5469 69.3232 90.2341 68.7695 89.6774C68.2158 89.1206 67.9048 88.3655 67.9048 87.5781V71.25C67.9048 70.4626 68.2158 69.7075 68.7695 69.1508C69.3232 68.594 70.0741 68.2812 70.8572 68.2812C71.6402 68.2812 72.3911 68.594 72.9448 69.1508C73.4985 69.7075 73.8095 70.4626 73.8095 71.25V72.7344Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M39.8572 29.2568V32.6561H29.5238C27.9578 32.6561 26.4559 33.2816 25.3485 34.3951C24.2412 35.5086 23.6191 37.0188 23.6191 38.5936V47.4998L20.6667 50.4686",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M53.1429 29.2568V32.6561H63.4762C65.0423 32.6561 66.5442 33.2816 67.6515 34.3951C68.7589 35.5086 69.381 37.0188 69.381 38.5936V47.4998L72.3334 50.4686",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0476 50.4688H17.7143C16.899 50.4688 16.2381 51.1333 16.2381 51.9531V59.375C16.2381 60.1948 16.899 60.8594 17.7143 60.8594H28.0476C28.8629 60.8594 29.5238 60.1948 29.5238 59.375V51.9531C29.5238 51.1333 28.8629 50.4688 28.0476 50.4688Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M75.2857 50.4688H64.9524C64.1371 50.4688 63.4762 51.1333 63.4762 51.9531V59.375C63.4762 60.1948 64.1371 60.8594 64.9524 60.8594H75.2857C76.101 60.8594 76.7619 60.1948 76.7619 59.375V51.9531C76.7619 51.1333 76.101 50.4688 75.2857 50.4688Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5238 53.4375H63.4762",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5238 59.375H36.9048L41.3333 63.8281H50.1905L54.619 59.375H63.4762",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M67.9047 72.7344V86.0938H64.0519C62.807 86.0859 61.5733 86.3303 60.4244 86.8123C59.2755 87.2943 58.2349 88.0041 57.3647 88.8992C55.9531 90.3607 54.2641 91.5226 52.3979 92.316C50.5317 93.1094 48.5261 93.5182 46.5 93.5182C44.4738 93.5182 42.4683 93.1094 40.602 92.316C38.7358 91.5226 37.0469 90.3607 35.6352 88.8992C34.765 88.0041 33.7244 87.2943 32.5755 86.8123C31.4266 86.3303 30.1929 86.0859 28.9481 86.0938H25.0952V72.7344H28.9481C30.1929 72.7422 31.4266 72.4978 32.5755 72.0158C33.7244 71.5338 34.765 70.8241 35.6352 69.9289C36.4616 69.078 37.383 68.3259 38.3809 67.6875V65.3125C38.3809 64.9188 38.5365 64.5413 38.8133 64.2629C39.0901 63.9845 39.4656 63.8281 39.8571 63.8281H53.1428C53.5343 63.8281 53.9098 63.9845 54.1867 64.2629C54.4635 64.5413 54.619 64.9188 54.619 65.3125V67.6875C55.617 68.3259 56.5383 69.078 57.3647 69.9289C58.2349 70.8241 59.2755 71.5338 60.4244 72.0158C61.5733 72.4978 62.807 72.7422 64.0519 72.7344H67.9047Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M42.8095 69.7656H50.1905",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 95,
    viewBox: "0 0 93 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.1b5e9d4c.svg";
export { ForwardRef as ReactComponent };